import { IconButton, IconButtonProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PencilEdit from '../../../assets/icons/PencilEdit';

const EditButton = <C extends React.ElementType>({
  sx,
  ...props
}: IconButtonProps<C, { component?: C }>) => {
  const theme = useTheme();
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        '&:focus': {
          outline: `solid 2px ${theme.palette.primary.main}`,
          outlineOffset: '4px',
          borderRadius: '50%',
          backgroundColor: 'inherit',
        },
        ...sx,
      }}
    >
      <PencilEdit />
    </IconButton>
  );
};

export default EditButton;
